var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConditionalFormArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.1667,
    transform: "rotate(-180 20 20)",
    stroke: "#6B6B6B",
    strokeWidth: 1.66667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.584 24.0503L19.8496 16.4783L12.2776 24.0503",
    stroke: "#6B6B6B",
    strokeWidth: 3.33333
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConditionalFormArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/conditionalFormArrow.d42569e570462aa6577dcdebe85a99ab.svg";